import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import Appbar from 'react-toolbox/lib/app_bar'
import Navigation from 'react-toolbox/lib/navigation'
import { compose } from 'redux'
import { connect } from 'react-redux'

import { Tab } from 'containers/App/AppNavigation/constants'
import { tabIndexSelector } from 'containers/App/AppNavigation/selectors'
import {
  toggleNavigationDrawer,
} from 'containers/App/App/actions'
import {
  updateTabIndex,
} from 'containers/App/AppNavigation/actions'

import Link from './Link'
import { AdminLink, InternalLink } from './AdminLink'

import styles from './styles.scss'

const mapStateToProps = (state) => {
  return {
    tabIndex: tabIndexSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggle: () => dispatch(toggleNavigationDrawer()),
    updateTab: (tabIndex) => dispatch(updateTabIndex(tabIndex))
  }
}

class AppNavigationBar extends Component {
  toggleProduct = () => this.props.updateTab(Tab.PRODUCT.value)
  toggleProject = () => this.props.updateTab(Tab.PROJECT.value)
  toggleReport = () => this.props.updateTab(Tab.REPORT.value)
  toggleManage = () => this.props.updateTab(Tab.MANAGE.value)
  toggleAdmin = () => this.props.updateTab(Tab.ADMIN.value)

  render() {
    const { tabIndex, toggle } = this.props
    return (
      <Appbar theme={styles} rightIcon='close' onRightIconClick={toggle}>
        <Navigation theme={styles} type='horizontal'>
          <AdminLink onClick={this.toggleProduct} active={Tab.PRODUCT.value === tabIndex} label='Product'/>
          <Link onClick={this.toggleProject} active={Tab.PROJECT.value === tabIndex} label='Project'/>
          <InternalLink onClick={this.toggleReport} active={Tab.REPORT.value === tabIndex} label='Report'/>
          <InternalLink onClick={this.toggleManage} active={Tab.MANAGE.value === tabIndex} label='Manage'/>
          <AdminLink onClick={this.toggleAdmin} active={Tab.ADMIN.value === tabIndex} label='Admin'/>
        </Navigation>
      </Appbar>
    )
  }
}

const withStyle = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const enhance = compose(
  withConnect,
  withStyle
)

export default enhance(AppNavigationBar)
